/**
 * Opens the Intercom chat widget
 * Provides a unified way to open Intercom across the application
 */
export function openIntercomChat(): void {
  if (typeof window !== 'undefined' && typeof window.Intercom === 'function') {
    try {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-call
      window.Intercom('show');
      console.log('Intercom chat opened successfully');
    } catch (error) {
      console.error('Error opening Intercom chat:', error);
    }
  } else {
    console.error('Intercom is not initialized or not available');
  }
}

/**
 * Opens the Intercom help center
 */
export function openIntercomHelp(): void {
  if (typeof window !== 'undefined' && typeof window.Intercom === 'function') {
    try {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-call
      window.Intercom('showSpace', 'help');
      console.log('Intercom help center opened successfully');
    } catch (error) {
      console.error('Error opening Intercom help center:', error);
    }
  } else {
    console.error('Intercom is not initialized or not available');
  }
}

/**
 * Opens the Intercom home tab
 */
export function openIntercomHome(): void {
  if (typeof window !== 'undefined' && typeof window.Intercom === 'function') {
    try {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-call
      window.Intercom('showSpace', 'home');
      console.log('Intercom home tab opened successfully');
    } catch (error) {
      console.error('Error opening Intercom home tab:', error);
    }
  } else {
    console.error('Intercom is not initialized or not available');
  }
}

/**
 * Opens a specific article in the Intercom widget
 * @param articleId - The numeric ID of the article (found in the article URL)
 */
/**
 * Opens the Intercom chat with a pre-filled message
 */
export function openIntercomNewMessage(message: string): void {
  if (typeof window !== 'undefined' && typeof window.Intercom === 'function') {
    try {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-call
      window.Intercom('showNewMessage', message);
    } catch (error) {
      console.error('Error opening Intercom new message:', error);
    }
  } else {
    console.error('Intercom is not initialized or not available');
  }
}

export function openIntercomArticle(articleId: number): void {
  if (typeof window !== 'undefined' && typeof window.Intercom === 'function') {
    try {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-call
      window.Intercom('showArticle', articleId);
    } catch (error) {
      console.error('Error opening Intercom article:', error);
    }
  } else {
    console.error('Intercom is not initialized or not available');
  }
}
